import { h } from "preact";

import { withMultiSelectGridItem, WithMultiSelectGridItemProps } from "../../MultiSelect/MultiSelectGrid";

import ComponentCard, { ComponentCardProps } from "./ComponentCard";

type Props = Required<WithMultiSelectGridItemProps> & ComponentCardProps;

function SelectableComponentCard(props: Props) {
    const {
        selectableRef,
        onGridItemSelect,
        itemSelected,
        itemSelecting,
        ...rest
    } = props;

    return (
        <ComponentCard
            baseRef={selectableRef}
            highlighted={itemSelected || itemSelecting}
            onClick={onGridItemSelect}
            {...rest}/>
    );
}

export default withMultiSelectGridItem(SelectableComponentCard);
